import React, { useEffect, useState } from 'react'
import dynamic from 'next/dynamic'
import Navbar from "../components/Layouts/Navbar";
import HeroBanner from '../components/Common/HeroBanner';
import Breadcrumb from '../components/Layouts/Breadcrumb';
import SectionHeading from "../components/Common/SectionHeading";
import Head from 'next/head';
import Link from 'next/link'
import axios from 'axios';
const Footer = dynamic(() => import('../components/Layouts/Footer', { ssr: false }));


const PrivacyPolicy = ({title, description , keywords}) => {

  const [scrolled, setScrolled] = useState(0)
  const [scrolledStatus, setScrolledStatus] = useState(false)


  useEffect(() => {
    const onScroll = () => setScrolled(window.pageYOffset);
    // clean up code
    window.removeEventListener('scroll', onScroll);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    if (scrolled > 30) {
      setScrolledStatus(true)
    }
  }, [scrolled])



  return (
    <>
      <Head>
        <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="keywords" content={keywords} />
        <link rel="apple-touch-icon" href="https://assets.delveinsight.com/png/delve-favicon.png" type="image/png" />
        <link rel="shortcut icon" href="https://assets.delveinsight.com/png/delve-favicon.png" type="image/png" />
        {/*  Yandex-site-verification  */}
        {/* <meta name="yandex-verification" content="784b07ceaf132b92" /> */}
        <meta name="yandex-verification" content="f1d711d11676531b" />
        <meta property="og:title" content={title} />
        <meta property="og:image" content="https://assets.delveinsight.com/img/delveinsight.png" />
        <meta property="og:image:secure_url" content="https://assets.delveinsight.com/img/delveinsight.png" />
        <meta property="og:type" content="website" />
        {/*  Twitter cards  */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:image" content="https://assets.delveinsight.com/img/delveinsight.png" />
        <meta name="twitter:site" content="@delve_insight" />
        <meta name="google-site-verification" content="hH_dRptj_rM-_DekPa6kdZP1K2Szwv0_9omQ-PLk7Z4" />
      </Head>
      <Navbar />
      <>
        <HeroBanner
          background={process.env.IMG_CDN + "img/banner/privacy-policy-page.webp"}
          title={<>DelveInsight&apos;s Privacy Policy</>}
        />
        <Breadcrumb />
        <div className="w-11/12 xl:max-w-screen max-w-screen-2xl flex flex-col justify-center mx-auto lg:my-8 my-4">
          <SectionHeading
            title="Welcome to DelveInsight&apos;s Privacy Policy"
          />
          <div className='grid grid-cols-12'>
            <div className='col-span-12'>
              <div className='text-justify'>
                <p>DelveInsight has issued this privacy statement to ensure the clients of its commitment to the privacy of the clients. In accordance with its necessary and healthy business practices, DelveInsight collects and processes personal information relating to its clients. The Privacy policy, hereby set, lays down how DelveInsight intends to use the information thus collected from the clients. DelveInsight is committed to being transparent about how it collects and uses that data, and to meeting its data protection obligations. This Privacy Policy applies to the Website and all products and services offered by the firm.</p>
                <p>We receive and store any information you input. This information can be collected in variety of ways such as website registration forms, customer-initiated chat applications, payment submission forms, notes collected through phone conversations, etc. However, you may choose to not enter certain information and doing so will also restrict the availability of certain services which DelveInsight is able to provide. Data thus collected can be stored in variety of ways, including in HR management systems, on other IT systems (including email), and marketing and sales-related software/spreadsheets.</p>
                <h3 className="text-lg font-semibold mb-4 text-[#1b5df3]">IP Address</h3>
                <p>When you visit DelveInsight, the IP address of your PC is recorded in order to help diagnose and troubleshoot server related problems. Your IP address helps us to ensure to track any activity thus made by your server and keep a record of it. It also helps us to identify you whenever you make any purchases.</p>
                <h3 className="text-lg font-semibold mb-4 text-[#1b5df3]">Personal Information</h3>
                <p>Such as name, address, contact details, and email. This type of information is received when you subscribe to our newsletter services, and when submit a question or inquire about our products/services via any means.</p>
                <h3 className="text-lg font-semibold mb-4 text-[#1b5df3]">Payment Details</h3>
                <p>This information is collected when purchases are made.</p>
                <h3 className="text-lg font-semibold mb-4 text-[#1b5df3]">Usage and Purchase History</h3>
                <p>We also collect and track your Usage and purchasing history in order to advise you better regarding Current Market scenarios.</p>
                <h3 className="text-lg font-semibold mb-4 text-[#1b5df3]">Cookies and other technical or site function data</h3>
                <p>DelveInsight uses cookies and other technology to track the usage of the website. This keeps us updated on how many people visit certain reports or pages on the site. This feature also helps us to customize your experience.</p>
                <h3 className="text-lg font-semibold mb-4 text-[#1b5df3]">Login Information</h3>
                <p>Your ID and site password is stored for verification purpose for future visits and purchases.</p>
                <h3 className="text-lg font-semibold mb-4 text-[#1b5df3]">RSS Feed Guidelines</h3>
                <p>DelveInsight encourages its readers to gain insights from our knowledge center, however, we advise against using any form of our content without proper acknowledgment and accreditation.</p>
                <p>We would like you to spread the knowledge more, however, we would like it more if you ask for permission and do not make any edits to the original text before doing so. We advised against the use of our RSS feeds without any prior permission. We also forbid manual submission of RSS feeds by any other entity.</p>
                <p>DelveInsight reserves all the rights to each piece of content published on the website. For any enquiry related to RSS Feeds contact us at
                  <Link href="mailto:info@delveinsight.com" className='text-[#1b5df3]'>
                    <strong> info@delveinsight.com</strong>
                  </Link>
                </p>
                <hr className='border-t-[#1b5df3]' />
                <p>Information about our client’s is a predominant part of the business. DelveInsight treats all of its clients personal information with utmost care and commits to keep it securely. We do not sell, trade, rent or share any part of the information to third parties. The data collected is only used to provide DelveInsight’s product and service-related updates via Newsletters. DelveInsight adopts appropriate security measures to prevent unauthorized access, disclosure, alteration, and destruction of client’s personal information. Exchange of data between the client and the company takes place over SSL secured channel and is encrypted and fully secured.</p>
                <p>If the client wishes to opt-out of the services provided by DelveInsight or experiences any uneasiness while sharing certain details, DelveInsight and its team is all open to understand and solve queries. If the issues of worry still persist, the client can anytime unsubscribe from DelveInsight’s newsletter services and email correspondence. DelveInsight ensures to amend client’s request regarding suppressing of personal details; however, for the transitional period of processing the request, the client may receive the updates.</p>
                <p>DelveInsight reserves the rights to update or modify this privacy policy with time to keep up with the changing legal norms of the different geographies. The clients are encouraged to check this section from time to time to keep themselves informed about the changes the company has been undertaking to ensure its client’s security.</p>
                <hr className='border-t-[#1b5df3]' />
                <p>You may contact DelveInsight via email at
                  <Link href="mailto:info@delveinsight.com" className='text-[#1b5df3]'>
                    <strong > info@delveinsight.com</strong>
                  </Link> for further assistance.
                </p>
              </div>
            </div>
          </div>
        </div>
      </>
      {scrolledStatus && <>
        <Footer />
      </>}

    </>
  )
}

// PrivacyPolicy.getInitialProps = async (NextPageContext) => {
//   const slugData = NextPageContext.pathname
//   try {
//     const response = await axios.get(process.env.API_URL + '/meta' + slugData);
//     return {
//       title: (response?.data.meta_title) ? response?.data.meta_title : "Healthcare Market Research Reports & Consulting Firm | DelveInsight",
//       description: (response?.data.meta_description) ? response?.data.meta_description : "DelveInsight is a pioneer in Healthcare Market Research Reports & Consulting Services. We advise Pharma leaders on making strategic decisions across all therapy areas & geographies.",
//       keywords: (response?.data.meta_keywords) ? response?.data.meta_keywords : "pharmaceutical business consulting, market research company, pharma consulting, biotech consulting, pharma market research, pharma market insights, biotech consulting,  pharma consulting service, pharma leading, market trends.",
//     }
//   } catch (error) {
//     console.error('Error fetching data:', error.message);
//     return {
//       title: "Healthcare Market Research Reports & Consulting Firm | DelveInsight",
//       description: "DelveInsight is a pioneer in Healthcare Market Research Reports & Consulting Services. We advise Pharma leaders on making strategic decisions across all therapy areas & geographies.",
//       keywords: "pharmaceutical business consulting, market research company, pharma consulting, biotech consulting, pharma market research, pharma market insights, biotech consulting,  pharma consulting service, pharma leading, market trends.",
//     };
//   }
// }

export default PrivacyPolicy;

export async function getStaticProps() {
  try {
    const response = await axios.get(process.env.API_URL + '/meta' + '/privacy-policy');
    return {
      props:
      {
        title: (response?.data.meta_title) ? response?.data.meta_title : "Healthcare Market Research Reports & Consulting Firm | DelveInsight",
        description: (response?.data.meta_description) ? response?.data.meta_description : "DelveInsight is a pioneer in Healthcare Market Research Reports & Consulting Services. We advise Pharma leaders on making strategic decisions across all therapy areas & geographies.",
        keywords: (response?.data.meta_keywords) ? response?.data.meta_keywords : "pharmaceutical business consulting, market research company, pharma consulting, biotech consulting, pharma market research, pharma market insights, biotech consulting,  pharma consulting service, pharma leading, market trends.",
      }
    }
  } catch (error) {
    console.error('Error fetching data:', error.message);
    return  {
      props:
      {
      title: "Healthcare Market Research Reports & Consulting Firm | DelveInsight",
      description: "DelveInsight is a pioneer in Healthcare Market Research Reports & Consulting Services. We advise Pharma leaders on making strategic decisions across all therapy areas & geographies.",
      keywords: "pharmaceutical business consulting, market research company, pharma consulting, biotech consulting, pharma market research, pharma market insights, biotech consulting,  pharma consulting service, pharma leading, market trends.",
    }
  };
  }
}
